export function addMaskPhone(value: string) {
  if (value.length > 10) {
    return value.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  }
  return value.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
}
